import { Container, Title, Text, Paper, Button, Group } from '@mantine/core'
import { Link } from 'react-router-dom'
import Header from '../components/Header'
import { Seo } from '../components/Seo'
import { useAuth } from '../auth/AuthContext'

export default function BannedPage() {
  const { signOut } = useAuth()
  return (
    <>
      <Seo title="Аккаунт заблокирован" canonical="/banned" noindex />
      <Header />
      <Container size="sm" px={16} py="xl">
        <Paper withBorder shadow="xs" radius="md" p="lg" style={{ background: '#fff4e6', borderColor: 'var(--mantine-color-orange-4)' }}>
          <Title order={2} mb="sm">Аккаунт заблокирован</Title>
          <Text c="dimmed" mb="md">
            Доступ к сервису ограничен. Если считаете это ошибкой или хотите уточнить детали, напишите нам и укажите email учётной записи.
          </Text>
          <Group>
            <Button component="a" href="https://t.me/fravai_support_bot" target="_blank" rel="noopener" variant="outline" color="orange">
              Написать в Telegram
            </Button>
            <Button component="a" href="mailto:support@fravai.com" variant="filled" color="orange">Написать письмо</Button>
            <Button component={Link} to="/auth" onClick={() => signOut()} variant="light" color="gray">Выйти</Button>
          </Group>
        </Paper>
      </Container>
    </>
  )
}
